import { defineStore } from 'pinia'
import { ref } from 'vue'

type GeneratorsConditionStatusExportParameters = {
    startDate?: string
    endDate?: string
    measurementType?: string | number
    measurementPoint?: string | number
    analysisCommentsLength?: number
    recommendationsLength?: number
    masterDataShowMore?: string
}

export const useGeneratorsExportStateStore = defineStore('exportGeneratorsStateStore', () => {
    const conditionStatusExportParameters = ref<GeneratorsConditionStatusExportParameters>({})

    const resetConditionStatusExportParameters = () => {
        conditionStatusExportParameters.value = {}
    }

    return {
        conditionStatusExportParameters,
        resetConditionStatusExportParameters,
    }
})